import XLSX from 'xlsx'
import Vue from 'vue'
const NOME_TABELA = 'Planilha1'

const iniciar = (file, callback) => {
  const reader = new FileReader()
  reader.onload = async function (e) {
    var data = new Uint8Array(e.target.result)
    var workbook = await XLSX.read(data, { type: 'array' })
    await construirObjetoLaudo(workbook, (laudos) => {
      return callback(laudos)
    })
  }
  return reader.readAsArrayBuffer(file)
}

export default iniciar
export const nomePlanilha = NOME_TABELA

const construirObjetoLaudo = async (workbook, callback) => {
  const index = workbook.SheetNames.indexOf(NOME_TABELA)
  if (index > -1) {
    const worksheet = workbook.Sheets[NOME_TABELA]
    let laudos = await laudosToObject(worksheet)
    return callback(laudos)
  }
  return alert(`Não existe uma tabela com o nome ${NOME_TABELA} neste arquivo.`)
}

const laudosToObject = async worksheet => {
  let tabela = await XLSX.utils.sheet_to_json(worksheet, {
    raw: false,
    header: 'A'
  })

  tabela.shift()

  try {
    const laudos = await tabela.map((item) => {
      return {
        cpf: item.B,
        laudo: {
          data_coleta: Vue.options.filters.parseDateToDB(item.E),
          data_analise: Vue.options.filters.parseDateToDB(item.F),
          amostra_numero: item.G,
          gordura: (item.H) ? parseFloat(item.H) : null,
          proteina: (item.I) ? parseFloat(item.I) : null,
          lactose: (item.J) ? parseFloat(item.J) : null,
          solidos: (item.K) ? parseFloat(item.K) : null,
          esd: (item.L) ? parseFloat(item.L) : null,
          ccs: (item.M) ? parseFloat(item.M) : null,
          cpp: (item.N) ? parseFloat(item.N) : null
        }
      }
    })

    return laudos
  } catch (error) {
    alert('Ocorreu um erro durante a verificação do arquivo de laudos.')
    return console.error(error)
  }
}
